var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipsisRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2895 12.4371C17.2895 11.1949 18.3453 10.1871 19.6467 10.1871C20.948 10.1871 22.0038 11.1949 22.0038 12.4371C22.0038 13.6793 20.948 14.6871 19.6467 14.6871C18.3453 14.6871 17.2895 13.6793 17.2895 12.4371ZM9.4324 12.4371C9.4324 11.1949 10.4882 10.1871 11.7895 10.1871C13.0909 10.1871 14.1467 11.1949 14.1467 12.4371C14.1467 13.6793 13.0909 14.6871 11.7895 14.6871C10.4882 14.6871 9.4324 13.6793 9.4324 12.4371ZM6.28954 12.4371C6.28954 13.6793 5.23423 14.6871 3.9324 14.6871C2.63057 14.6871 1.57526 13.6793 1.57526 12.4371C1.57526 11.1949 2.63057 10.1871 3.9324 10.1871C5.23423 10.1871 6.28954 11.1949 6.28954 12.4371Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "white",
    transform: "translate(0.789551 0.437134)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisRegular);
export default __webpack_public_path__ + "static/media/ellipsis-regular.893d0f6ad72a589db5bfbea47b56aa9c.svg";
export { ForwardRef as ReactComponent };